export function getConfigProperty(key: string): string | never {
  const value = process.env[key];
  if (value) return value;

  throw new Error(`Invalid ${key}`);
}

export default getConfigProperty;
